export const getUserData = (key) => {
  return new Promise((resolve, reject) => {
    let userData = JSON.parse(localStorage.getItem(key));
    // console.log("getuserdata called", userData)
    if (userData) {
      resolve(userData);
    } else {
      reject({});
    }
  });
};

export const setUserData = (userData, key) => {
  return new Promise((resolve, reject) => {
    const data = JSON.stringify(userData);
    // const newTempData = {
    //   EmailId: "Nezih@mtsnyc.com",
    //   Fullname: "Nezih Akbas ",
    //   OrgnisationCodes: "AIRCONMIA",
    //   CountryCode: "TR",
    //   Roles: "Guest",
    //   Order: true,
    //   OrderPermisionCollection: {
    //     OrderDashBoard: true,
    //     CreateOrder: false,
    //     OrderList: true,
    //     OrderLog: true,
    //     OrderReport: true,
    //   },
    //   Shipment: true,
    //   ShipmentPermisionCollection: {
    //     ShipmentDashBoard: true,
    //     ShipmentList: false,
    //     ShipmentAnalytics: true,
    //     ShipmentReport: true,
    //     ShipmentMap: true,
    //     ShipmentMilstone: false,
    //     ShipmentDetail: true,
    //     ShipmentDocument: false,
    //   },
    //   Finance: true,
    //   FinancePermisionCollection: {
    //     StatementOfAccount: true,
    //   },
    //   Schedule: true,
    //   SchedulePermisionCollection: {
    //     Schedule: true,
    //   },
    //   CargoInsurance: true,
    //   CargoInsurancePermisionCollection: {
    //     CargoInsurance: true,
    //   },
    //   Rms: true,
    //   RmsPermisionCollection: {
    //     RmsLcl: true,
    //     RmsFcl: true,
    //   },
    // };
    localStorage.setItem(key, data);
    // localStorage.setItem("newTempData", JSON.stringify(newTempData));
    // console.log("Utility is setting the localstorage userData.", key, userData);
    resolve(true);
  });
};

export const checkUser = async (key) => {
  let userData = await JSON.parse(localStorage.getItem(key));
  if (userData) {
    if (
      userData.user_name === "serkan@mtsnyc.com" ||
      userData.user_name === "sedat@mtsnyc.com" ||
      userData.user_name === "gb@boucherco.com"
    ) {
      return true;
    } else {
      return false;
    }
  } else {
    return false;
  }
};

export const checkAdmin = async (key) => {
  let userData = await JSON.parse(localStorage.getItem(key));
  // console.log(userData, userData.user_roles === "ADM");
  if (userData) {
    if (userData.user_roles === "ADM") {
      return true;
    } else {
      return false;
    }
  } else {
    return false;
  }
};
